// @flow
import * as React from 'react';
import { get, isPlainObject } from 'lodash';
import connectAPI from 'speed-js-react/src/api/connectAPI';
import ApiClient from 'speed-js-core/src/api/ApiClient';
import ModelPage from 'esm-web-pro/containers/pages/ModelPage';

type SidePanelActionProps = {
    closePanel: (key: string) => { key: string },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    redirectTo: string,
    resourceName: string,
    resourceArguments?: Array<any>;
    title: (initial: Object) => React.Node | Object,
    createResource: string,
    onClose: Function,
    history: Object,
    match: Object,
    nestedInitials?: boolean,
    useFormInitial?: boolean,
    initialsCallback?: (initial: Object) => Object,
    editObjectFormProps?: Object,
};

type CombinedProps = Props & {
    getInitials: () => Promise<Object>,
    initial: Object,
};

const EditModelPage = (props: CombinedProps) => {
    const {
        title, initial, getInitial, useFormInitial, initialsCallback, resourceName, resourceArguments,
        editObjectFormProps, nestedInitials, match: { params: { id } }, ...rest
    } = props;
    const [initials, setInitials] = React.useState(null);

    React.useEffect(() => {
        getInitial().then((response) => {
            if (initialsCallback) {
                setInitials(initialsCallback(response));
            } else {
                setInitials(response);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resourceName, resourceArguments, initialsCallback, nestedInitials, id]);

    return (
        <ModelPage
            title={typeof title === 'function' ? title(initial) : title}
            initial={initials}
            useInitial={useFormInitial}
            resourceName={resourceName}
            resourceArguments={resourceArguments}
            newObjectFormProps={editObjectFormProps}
            {...rest}
        />
    );
};

EditModelPage.defaultProps = {
    resourceArguments: [],
    nestedInitials: false,
    useFormInitial: false,
    initialsCallback: undefined,
    editObjectFormProps: {},
};

const apiCallback = (apiClient: ApiClient, props: CombinedProps) => ({
    getInitial: {
        send: () => {
            const objectId = props.match.params.id;
            if (!objectId) return null;

            let data = {};
            if (!props.nestedInitials) {
                data.nonested = 1;
            }

            if (isPlainObject(props.resourceArguments)) {
                data = { ...data, ...props.resourceArguments };
            } else if (props.resourceArguments) {
                return get(apiClient.resources, props.resourceName).get(...props.resourceArguments, objectId, data);
            }

            return get(apiClient.resources, props.resourceName).get(objectId, data);
        },
        success: (initial: Object) => ({ initial }),
    },
});

export default connectAPI(apiCallback)(EditModelPage);
